export function refToCallback(ref) {
  return function (newValue) {
    if (typeof ref === 'function') {
      ref(newValue);
    } else if (ref) {
      ref.current = newValue;
    }
  };
}

var nullCallback = function nullCallback() {
  return null;
}; // lets maintain a weak ref to, well, ref :)
// not using `kashe` to keep this package small


var weakMem = new WeakMap();

var weakMemoize = function weakMemoize(ref) {
  var usedRef = ref || nullCallback;

  if (weakMem.has(usedRef)) {
    return weakMem.get(usedRef);
  }

  var cb = refToCallback(usedRef);
  weakMem.set(usedRef, cb);
  return cb;
};

export function useRefToCallback(ref) {
  return weakMemoize(ref);
}